import { AppRouter } from "app/router/AppRouter";

export default function App() {
  return <AppRouter />;
}
